import styled from "@emotion/styled";
import { BaseCell } from "src/components/Table/Cells/shared";
import { timeAgo } from "src/utils";

const CellContainer = styled(BaseCell)``;

interface ApplicationDateCellProps {
  date: string;
}

export const ApplicationDateCell = ({ date }: ApplicationDateCellProps) => (
  <CellContainer>{timeAgo(date)}</CellContainer>
);
